export const listHeadingStyles = { fontSize: '1.2rem', marginBottom: '15px', fontWeight: 500 };

export const listItemStyles = {
  marginBottom: '15px',
  display: 'flex',
  alignItems: 'center',
};

export const listItemTextStyles = { fontSize: '1.6rem', fontWeight: 700, marginLeft: '10px' };
